<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-GuangChangWeiXuanZhong`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_443d1ca813__clip0_2102_4203)" stroke="#848484"><path d="M22.572 11.8899C22.572 17.5039 17.998 22.061 12.3481 22.061C6.69813 22.061 2.12415 17.5039 2.12415 11.8899C2.12415 6.27593 6.69813 1.71875 12.3481 1.71875C17.998 1.71875 22.572 6.27593 22.572 11.8899Z" stroke-width="1.5"/><path d="M3.36789 19.3521C2.34345 21.0941 1.97561 22.3794 2.47883 22.8824C3.65971 24.0627 9.19009 20.4885 14.8313 14.899C20.4725 9.30947 24.0883 3.82142 22.9074 2.64105C22.4363 2.17017 21.495 2.1649 19.9087 3.03344" stroke-width="1.6" stroke-linecap="round"/></g><circle cx="8" cy="11" :fill="useCurrentColor ? 'currentColor' : '#848484'" r="2"/><defs><clipPath id="svg_443d1ca813__clip0_2102_4203"><path :fill="useCurrentColor ? 'currentColor' : '#fff'" transform="translate(1 1)" d="M0 0H23V23H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconGuangChangWeiXuanZhong',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
